<template>
  <div class="error_container">
    <div class="error_top">
      <!-- <TopCard ref="TopCardRef"
               text="排行榜">
      </TopCard> -->
<img src="@/static/topCard/CaretCircleLeft.png"
          style="position: absolute;top:20rem; z-index:9999"
           @click="back"
           alt="">
    </div>
    <div class="error_bottom">

      <div class="subject_wrap">
        <div class="tabs">
          <div :class="{'item':true,'activeItem':index==activeIndex}"
               @click="checkItem(index,item)"
               v-for="(item,index) in tabList"
               :key="index">
            {{item.label}}
          </div>
        </div>
        <div class="subject_search">
          <div class="subject">
            <div v-for="(item,index) in subjectList"
                 :class="{'active_subject':subjectId == item.subject_id}"
                 @click="checkSubject(item,index)"
                 :key="item.subject_id">
              {{item.subject_name}}
            </div>
          </div>
        </div>
        <div class="type_id">

          <a-select style="width: 100%;"
                    v-model:value="a_type"
                     @change="checkType(a_type)"
                    placeholder="请选择">
            <a-select-option v-for="item in typeList"
                             :key="item.value"
                             :value="item.value">{{item.label}}
            </a-select-option>
          </a-select>
        </div>
      </div>

     
 
    <div v-if="tableData.length>0"
         style="background-color: #ffffff;height: 580rem;">
      <div class="list_wrap">
        <div class="img_list">
          <div style="margin-top: 40rem; position: relative;height:234rem  ">
            <img src="@/static/rank/2.png"
                 alt=""
                  style="height:308rem;width: 560rem; "
                 class="img" />
            <div v-if="top3[1]"
                 class="head3">
              <div style="display: flex;  gap: 20rem;  display: flex;
    justify-content: center;
    margin-bottom: 12rem;
    align-items: center;">
                <div class="head_img2">
                  <img :src="top3[1].avatar"
                       v-if="top3[1].avatar"
                       alt="">
                  <img src="@/static/myinfo/head.png"
                       v-else
                       alt="">
                </div>

                <div class="top3">
                  <div class="name">{{ top3[1]?top3[1].truename:"" }}</div>

                  <div class="school"
                       v-show="a_type==3">{{ top3[1]?top3[1].school_name:"" }}</div>
                </div>
              </div>
              <div class="bottom">
                <div class="num">{{type==1?'做题数量':'5套卷以上综合得分率'}} </div>
                <div class="num1"
                     v-if="top3[1]">{{ top3[1]&&type==1?top3[1].do_num+"题" :top3[1].rate+"%" }}</div>
              </div>
            </div>
            <div v-else
                 class="text3">暂无人上榜</div>

          </div>
          <div style="  position: relative;">
            <img src="@/static/rank/1.png"
                 alt=""
                    style="height:308rem;width: 560rem; "
                 class="img" />
            <div v-if="top3&&top3[0]"
                 class="head1">
              <div style="display: flex;  gap: 20rem;  display: flex;
                margin-bottom: 12rem;
    justify-content: center;
    align-items: center;">
                <div class="head_img2">
                  <img :src="top3[0].avatar"
                       v-if="top3[0].avatar"
                       alt="">
                  <img src="@/static/myinfo/head.png"
                       v-else
                       alt="">
                </div>
                <div class="top1">
                  <div class="name">{{ top3[0]?top3[0].truename:"" }}</div>

                  <div class="school"
                       v-show="a_type==3">{{ top3[0]?top3[0].school_name:"" }}</div>
                </div>
              </div>
              <div class="bottom1">
                <div class="num">{{type==1?'做题数量':'5套卷以上综合得分率'}} </div>
                <div class="num1"
                     v-if="top3[0]">{{ type==1?top3[0].do_num+"题" :top3[0].rate+"%" }}</div>
              </div>
            </div>
            <div v-else
                 class="text1">暂无人上榜 </div>
          </div>
          <div style="margin-top: 42rem;position: relative; ">
            <img src="@/static/rank/3.png"
                 alt=""
                   style="height:308rem;width: 560rem; "
                 class="img" />
            <div v-if="top3[2]"
                 class="head2">
              <div style="display: flex; gap: 20rem;   display: flex;
                margin-bottom: 12rem;
    justify-content: center;
    align-items: center;">
                <div class="head_img2">
                  <img :src="top3[2].avatar"
                       v-if="top3[2].avatar"
                       alt="">
                  <img src="@/static/myinfo/head.png"
                       v-else
                       alt="">
                </div>
                <div class="top2">
                  <div class="name">{{ top3[2]?top3[2].truename:"" }}</div>

                  <div class="school"
                       v-show="a_type==3">{{ top3[2]?top3[2].school_name:"" }}</div>
                </div>
              </div>
              <div class="bottom2">
                <div class="num">{{type==1?'做题数量':'5套卷以上综合得分率'}}</div>
                <div class="num1"
                     v-if="top3[2]">{{ type==1?top3[2].do_num+"题" :top3[2].rate+"%" }}</div>
              </div>
            </div>
            <div v-else
                 class="text2">暂无人上榜</div>

          </div>
        </div>
        <a-table
    :dataSource="tableData"
    :columns="columns"
      :sticky="true"
    
  :scroll="{ y: 400 }"
    :pagination="false"
   :row-class-name="(_record, index) => (_record.id == myList.id ? 'table-striped' : null)"
    bordered
    size="middle"
  >
    <!-- 排名列 -->
    <template #bodyCell="{ column, record }">
      <!-- 排名 -->
      <template v-if="column.dataIndex === 'ranking'">
        <img
          v-if="record.ranking === 1"
          src="@/static/rank/排行榜1.png"
          alt=""
        />
        <img
          v-else-if="record.ranking === 2"
          src="@/static/rank/排行榜2.png"
          alt=""
        />
        <img
          v-else-if="record.ranking === 3"
          src="@/static/rank/排行榜3.png"
          alt=""
        />
        <span v-else>{{ record.ranking === 0 ? '-' : record.ranking }}</span>
      </template>

      <!-- 用户列 -->
      <template v-if="column.dataIndex === 'user'">
        <div style="display: flex  ;margin-left: 230rem;gap: 12rem; ">
          
            <img :src="record.avatar"
                  style="  width: 44rem;
        height: 44rem; 
        border-radius: 50%;"
                           v-show="record.avatar"
                           alt="">
                      <img src="@/static/myinfo/head.png"
                           v-show="!record.avatar"
                           style="  width: 44rem;
        height: 44rem;
        border-radius: 50%;"
                           alt="">
          <div style="display: flex; flex-direction: column; align-items: flex-start; ">
            <span>{{ record.truename }}</span>
            <span v-show="a_type&&a_type == 3">{{ record.school_name }}</span>
          </div>
        </div>
      </template>

      <!-- 成绩列（做题数量 / 得分率） -->
      <template v-if="column.dataIndex === 'score'">
        {{
          type === 1
            ? record.do_num + '题'
            : (record.rate || 0) + '%'
        }}
      </template>
    </template>

    <!-- 追加“我的排名”行 -->
    <template #summary  >
      <a-table-summary fixed>
        <a-table-summary-row style="background: #e3f2fd">
          <a-table-summary-cell style="  text-align: center">
              <img src="@/static/rank/我的排名.png"
                         style="    position: absolute;
    top: 0rem;
    left: 1rem;"
                         alt="">
            <img
              v-if="myList.ranking == 1"
              src="@/static/rank/排行榜1.png"
              alt=""
            />
            <img
              v-else-if="myList.ranking == 2"
              src="@/static/rank/排行榜2.png"
              alt=""
            />
            <img
              v-else-if="myList.ranking == 3"
              src="@/static/rank/排行榜3.png"
              alt=""
            />
            <span v-else>{{ myList.ranking == 0 ? '-' : myList.ranking }}</span>
          </a-table-summary-cell>

          <a-table-summary-cell>
            <div style="display: flex; align-items: center;margin-left: 230rem; gap: 12px;">
            
                  <img :src="myList.avatar"
                  style="  width: 44rem;
        height: 44rem;
        border-radius: 50%;"
                           v-if="myList.avatar"
                           alt="">
                      <img src="@/static/myinfo/head.png"
                           v-else
                           style="  width: 44rem;
        height: 44rem;
        border-radius: 50%;"
                           alt="">
              <div style="display: flex; flex-direction: column; justify-content: center; align-items: flex-start;">
                <span>{{ myList.truename }}</span>
                <span v-if="a_type === 3">{{ myList.school_name }}</span>
              </div>
            </div>

            <!-- 提示文案 -->
             <div style="display: flex;justify-content: center;margin-top:10rem">
            <div v-if="myList.ranking == 0 && type == 2" style="color:#999">
              <img src="@/static/rank/加油1.png"
                                                    alt="">做够5套卷试试，冲刺排行榜 
              
            </div>
            <div v-if="myList.ranking == 0 && type == 1" style="color:#999">
              <img src="@/static/rank/加油1.png"
                                                    alt="">马上开始做题，保你榜上有名 
            </div>
            <div v-if="myList.ranking == 1" style="color:#999">
             <img src="@/static/rank/冠军.png"
                                                   alt=""> 冠军是起点，未来更闪耀
            </div>
            <div v-if="type == 2 && myList.rate == '0.00' && myList.ranking > 0" style="color:#999">
             <img src="@/static/rank/加油1.png"
                                                    alt=""> 再努努力，保你榜上有名
            </div>
            <div v-if="type == 2 && myList.rate != '0.00' && myList.ranking > 1" style="color:#999">
              <img src="@/static/rank/加油1.png"
                                                    alt="">再提高{{ myList.j_num }}%的得分率，就有机会超越上一名
            </div>
            <div v-if="type == 1 && myList.ranking > 1" style="color:#999">
              <img src="@/static/rank/加油1.png"
                                                    alt="">距离上一名仅差{{ myList.j_num }}题，再努力一点点就有机会超越
            </div>
               </div>
          </a-table-summary-cell>

          <a-table-summary-cell style="text-align: center;">
            {{
              type === 1
                ? (myList.do_num || 0) + '题'
                : (myList.rate || 0) + '%'
            }}
          </a-table-summary-cell>
        </a-table-summary-row>
      </a-table-summary>
    </template>
  </a-table>
      </div>
    </div>
    <div class="list_wrap1"
         v-else>
      <div><img src="@/static/rank/nodata.png"
             alt=""
             class="img" /></div>
      <div class="text2">暂无排行榜，加油做题冲榜~ </div>
    </div>
</div>
  </div>

</template>

<script setup>
import TopCard from '@/views/components/top_card/index.vue'

import { addPost } from '@/api/post.js'
import { nextTick, onMounted, ref, reactive, onUnmounted , computed} from 'vue'
import { getRankList, getUserSubject } from '@/api/subject.js'
import { useRoute,useRouter  } from 'vue-router'
import { message } from 'ant-design-vue'

// 表格列
const columns = computed(() => [
  { title: '排名', dataIndex: 'ranking', align: 'center', width: 300 },
  { title: '用户', dataIndex: 'user', align: 'center',width: 300 },
  { title: type.value === 1 ? '成绩（做题数量）' : '成绩（5套卷以上综合得分率）',
    dataIndex: 'score',
    align: 'center',width: 300
     }
])
let router = useRouter()
const back = () => {
  router.push('/index')
}
const rowClassName = (record) => {
  console.log(record.id,myList.value.id)
  return record.id == myList.value.id ? 'top3-row' : ''
}
let route = useRoute()
let showWindow = ref(false)
let mapRef = ref()
let subject_id = ref('')
let tableData = ref([])
let myList = ref([])
let top3 = ref([])
let activeIndex = ref(0)
let subjectId = ref(null)
let a_type = ref(1)
let type = ref(1)
const tabList = ref([
  { value: 1, label: '做题数量' },
  { value: 2, label: '得分率' }
])
const typeList = ref([

  { label: '全国排名', value: 1 },
  { label: '本省排名', value: 2 },
  { label: '本校排名', value: 3 },
])
onMounted(() => {
  getSubject()
  setTimeout(() => {
     getRankInfo()
  },1000)
 
  nextTick(() => {

  })


})
const checkItem = (index, item) => {
  activeIndex.value = index
  type.value = item.value
  getRankInfo()

}
const checkSubject = (item, index) => {
  console.log(item)
  subjectId.value = item.subject_id
getRankInfo()
}
const checkType = (val) => {
  a_type.value = val
  getRankInfo()
}

//  const store = useStore()
let subjectList = ref([])
const getSubject = async () => {

  const { data } = await getUserSubject()
  subjectList.value = data.list
  subjectId.value = data.list[0].subject_id

}
let questionInfo = reactive({ volist: [] })
// 获取收藏题目详情
const getRankInfo = async (id) => {


  const { data } = await getRankList({
    type: type.value,
    a_type: a_type.value,
    subject_id: subjectId.value
  })
  tableData.value = data.list
   myList.value = data.my
      const possibleKeys = ['do_j_num', 'rate'];
      const pickCount = item => {
        const key = type.value == 2 ? possibleKeys[1] : possibleKeys[0];
        return Number.isFinite(item[key]) ? item[key] : 0;
      };

      const top = data.list
        .slice()
        .sort((a, b) => pickCount(b) - pickCount(a))
        .slice(0, 3);
      console.log('top', top)
     top3.value = top
        console.log('top3ddddd', top3.value)
}
 

 
 
onUnmounted(() => {
  window.sessionStorage.removeItem("sessionNodeList")
})

 

</script>

<style lang="scss" scoped>
 ::v-deep .tabs {
  font-weight: normal !important;
}
::v-deep .ant-table-body{
  min-height:158px;
}
::v-deep .activeItem {
  font-weight: 800;
}
::v-deep  .ant-select-selector{
  padding:0 24px !important;
}
::v-deep .ant-select-arrow {
font-size: 22px;
right:28px;
top: 45%;
color: #333;
}
::v-deep  .ant-select-single:not(.ant-select-customize-input) .ant-select-selector{
  padding: 0 15px;
}
::v-deep .subject_search .active_subject {
  font-weight: bold !important;
  color: #333 !important;
}
.ant-table.ant-table-middle tfoot > tr > td
{  padding: 13px 8px;
}
 :deep(.table-striped) td {
  // background-color:   rgb(227, 242, 253);
  color: var(--Brand-Color_6default, #2196F3);

}
.error_container {
  background: #f5f5f5;
  ::v-deep .ant-select-selector {
    border-radius: 30rem;
    height: 56rem;
    // border: solid 1px #cccccc;
  }
  ::v-deep .ant-select-selector .ant-select-selection-item {
    line-height: 54rem;
    font-size: 24rem;
  }
  ::v-deep .ant-select-selector .ant-select-selection-placeholder {
    line-height: 54rem;
    font-size: 24rem;
  }
  .error_bottom {
    height: calc(100vh - 100rem);
    display: flex;
    position: relative;
    flex-direction: column;
    padding-top: 26rem;
      .list_wrap {
    background: #ffffff;
    // margin-top: 26rem; 
height: 679rem;
    padding-left: 20rem;
    overflow: scroll;
    -ms-overflow-style: none;
    scrollbar-width: none;
    ::v-deep ::-webkit-scrollbar {
      display: none;
    }
    ::v-deep .el-table th {
      text-align: center;
    }
    .head_img {
      display: flex;
      justify-content: center;
      img {
        width: 44rem;
        height: 44rem;
        border-radius: 50%;
      }
    }
    .img_list {
      width: 1776px;
      // height: 433px;
      flex-shrink: 0;
      display: flex;
      gap: 92rem;
      .head_img1 {
        position: absolute;
        top: 56%;
        left: 25%;
        flex-direction: column;
        align-items: center;
        transform: translate(-50%, -50%);
        width: 100%;
        display: flex;
        justify-content: center;
        img {
          width: 44rem;
          height: 44rem;
          border-radius: 50%;
        }
      }
      .head2 {
        position: absolute;
        top: 55%;
        width: 100%;
      }
      .head1 {
        position: absolute;
        top: 49%;
        // left: 50%;
        width: 100%;
      }
      .head3 {
        position: absolute;
        top: 72%;
        // left: 50%;
        width: 100%;
      }
      .head_img2 {
        flex-direction: column;
        align-items: center;
        // transform: translate(-50%, -50%);
        // width: 100%;
        display: flex;
        justify-content: center;
        img {
          width: 44rem;
          height: 44rem;
          border-radius: 50%;
        }
      }
      .head_img3 {
        position: absolute;
        top: 56%;
        left: 25%;
        flex-direction: column;
        align-items: center;
        // transform: translate(-50%, -50%);
        width: 100%;
        display: flex;
        justify-content: center;
        img {
          width: 44rem;
          height: 44rem;
          border-radius: 50%;
        }
      }
      .bottom {
        display: flex;
        // position: absolute;
        // top: 85%;
        // left: 50%;
        // transform: translate(-50%, -50%);
        width: 100%;
        justify-content: space-around;
        // gap: 213rem;
        .num {
          color: var(--light-999999, #999);
          font-size: 24rem;
          font-style: normal;
          font-weight: 400;
          line-height: 36px; /* 150% */
        }
        .num1 {
          color: var(--light-333333, #333);
          font-size: 24rem;
          font-style: normal;
          font-weight: 600;
          line-height: 36px; /* 150% */
        }
      }
      .text3 {
        display: flex;
        position: absolute;
        top: 87%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        justify-content: center;
        color: var(--light-999999, #999);
        font-size: 24rem;
      }
      .text1 {
        display: flex;
        position: absolute;
        top: 65%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        justify-content: center;
        color: var(--light-999999, #999);
        font-size: 24rem;
      }
      .text2 {
        display: flex;
        position: absolute;
        top: 70%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        justify-content: center;
        color: var(--light-999999, #999);
        font-size: 24rem;
      }
      .bottom2 {
        display: flex;
        // position: absolute;
        // top: 85%;
        // left: 50%;
        // transform: translate(-50%, -50%);
        width: 100%;
        justify-content: space-around;
        // gap: 213rem;
        .num {
          color: var(--light-999999, #999);
          font-size: 24rem;
          font-style: normal;
          font-weight: 400;
          line-height: 36px; /* 150% */
        }
        .num1 {
          color: var(--light-333333, #333);
          font-size: 24rem;
          font-style: normal;
          font-weight: 600;
          line-height: 36px; /* 150% */
        }
      }
      .bottom1 {
        display: flex;
        // position: absolute;
        // top: 75%;
        // left: 52%;
        // transform: translate(-50%, -50%);
        width: 100%;
        justify-content: space-around;
        // gap: 213rem;
        .num {
          color: var(--light-999999, #999);
          font-size: 24rem;
          font-style: normal;
          font-weight: 400;
          line-height: 36px; /* 150% */
        }
        .num1 {
          color: var(--light-333333, #333);
          font-size: 24rem;
          font-style: normal;
          font-weight: 600;
          line-height: 36px; /* 150% */
        }
      }
      .top3 {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        // transform: translate(-50%, -50%);
        // width: 100%;
        .name {
          color: var(--light-333333, #333);

          font-size: 28rem;
          font-style: normal;
          font-weight: 600;
        }
        .school {
          color: var(--light-333333, #333);
          font-size: 24rem;
          font-style: normal;
          font-weight: 400;
          line-height: 36px; /* 150% */
        }
      }
      .top2 {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        // transform: translate(-50%, -50%);
        // width: 100%;
        .name {
          color: var(--light-333333, #333);

          font-size: 28rem;
          font-style: normal;
          font-weight: 600;
        }
        .school {
          color: var(--light-333333, #333);
          font-size: 24rem;
          font-style: normal;
          font-weight: 400;
          line-height: 36px; /* 150% */
        }
      }
      .top1 {
        // position: absolute;
        // top: 56%;
        // left: 55%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        // transform: translate(-50%, -50%);
        // width: 100%;
        .name {
          color: var(--light-333333, #333);

          font-size: 28rem;
          font-style: normal;
          font-weight: 600;
        }
        .school {
          color: var(--light-333333, #333);
          font-size: 24rem;
          font-style: normal;
          font-weight: 400;
          line-height: 36px; /* 150% */
        }
      }
    }
  }
    .list_wrap1 {
    background: #ffffff;
    // margin-top: 26rem;
    height: 664rem;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    // padding-left: 20rem;
    .text2 {
      overflow: hidden;
      color: var(--light-999999, #999);
      text-overflow: ellipsis;

      font-size: 28px;
      font-style: normal;
      font-weight: 400;
      line-height: 42px; /* 150% */
    }
  }
    .subject_wrap {
      .subject_search {
        display: flex;
        height: 60rem;
        justify-content: center;
        background: #ffffff;
        align-items: center;
        width: 100%;
        // border-bottom: 2rem #e5e5e5 solid;
        box-shadow: inset 0px -1px 0px 0px #cedaee;
        .subject {
          flex: 1;
          display: flex;
          justify-content: center;
          .active_subject {
            border-bottom: 4rem solid #1890ff;
            // color: #2196f3 !important;
            z-index: 1999;
          }
          div {
            font-size: 20rem;
            font-weight: normal;
            color: #333333;
            padding: 0 14rem;
            margin: 0 20rem;
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 47rem;
          }
        }
        .active_subject {
          border-bottom: 4rem solid #1890ff;
          
          // color: #2196f3 !important;
          z-index: 1999;
        }
      }
      width: 100%;
      display: flex;
      align-items: center;
      flex-direction: column;
      .tabs {
        width: calc(100% - 42.86%);
        display: flex;
        justify-content: center;
        border-radius: 30rem;
        background: #ffffff;
        height: 54rem;
        font-size: 24rem;
        font-weight: 800;
        overflow: hidden;
        .item {
          flex: 1;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #2196f3;
          cursor: pointer;
        }
      }
      .activeItem {
        background: #2196f3;
        color: #ffffff !important;
      }
      ::v-deep .subject_search {
        border-bottom: 1px solid var(--light-eeeeee, #eee);
        background: transparent;
        box-shadow: none;
        margin-bottom: 26rem;
        .subject {
          div {
            margin: 0px 40rem;
          }
        }
      }
      .type_id {
        display: inline-block;
        margin-left: 1420rem;
margin-bottom: 24rem;
        background: #fff;
        overflow: hidden;
        border-radius: 30rem;
        width: 320rem;
        height: 56rem;
      }
    }
  }
}
.line_move {
  width: 3px;
  padding: 0;
  border: 0;
  background: #e6e6e6;
  cursor: col-resize;
}
.error_left {
  background: #fff;
  width: 50%;
  height: 100%;
  overflow: auto;
}
.error_right {
  flex: 1;
  margin-left: 24px;
}
.float_window {
  position: absolute;
  left: 52%;
  top: 24px;
  z-index: 5;
  .move_box {
    position: absolute;
    // background: #333;
    left: 0;
    width: 100%;
    border-radius: 20rem 20rem 0 0;
    height: 20rem;
    cursor: move;
  }
}
// .map_wrap {
//   height: calc(100vh - 100rem);
// }
</style>